import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { SafeUrl, DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ResizedEvent } from "angular-resize-event";
import { Subscription } from "rxjs";
import { CallerPatient } from "src/app/model/caller-patient";
import { AdmissionService } from "src/app/services/admission.service";
import { MessageServerService } from "src/app/services/hub-services/message-server/message-server.service";
import { MenuService } from "src/app/services/menu.service";
import Swal from "sweetalert2";


@Component({
  selector: 'app-caller-patient-panel',
  templateUrl: './caller-patient-panel.component.html',
  styleUrls: ['./caller-patient-panel.component.css']
})
export class CallerPatientPanelComponent  implements OnInit, OnDestroy {

  [x: string]: any;
  value = 'active';
  videoUrl: string;
  sectorIds: number[] = [];
  soundName: string;
  callers: CallerPatient[];
  backGroundColor: string;
  callerBackGroundColor: string;
  callerTextColor: string;
  textColor: string;
  viewPatient: boolean;
  viewAmount?: number;
  showAlert: boolean;
  isOrientation: boolean;
  heightContent: number;
  heightLogo: number;

  logo: SafeUrl;
  left = '48';
  right = '49';
  audio: any;
  loading: boolean;
  callerReceivedSubcription: any;
  openReceivedSubscription: Subscription;

  constructor( private messageServerService: MessageServerService,
               private route: ActivatedRoute,
               private zone: NgZone,
               private admissionService: AdmissionService,
               private sanitizer: DomSanitizer
               ) {

    messageServerService.joinCallerGroup();
    this.audio = null;
   }

  ngOnDestroy(): void {
    this.callerReceivedSubcription.unsubscribe();
    this.openReceivedSubscription.unsubscribe();
  }

  ngOnInit() {
    this.route.params.subscribe(async params => {

      const id = params['Id'];
      const caller = await this.admissionService.getCaller(id);
      this.backGroundColor = caller.BackGroundColor;
      this.callerBackGroundColor = caller.CallerBackGroundColor;
      this.callerTextColor = caller.CallerTextColor;
      this.textColor = caller.TextColor;
      this.soundName = caller.SoundName;
      this.sectorIds = caller.SectorIds;
      this.viewPatient = caller.ViewPatient;
      this.viewAmount = caller.ViewAmount;
      this.showAlert = caller.ShowAlert;
      this.isOrientation = caller.IsOrientation;

      if ( !caller.VideoUrl ) {
        this.right = '100';
      } else {
        this.videoUrl = caller.VideoUrl;
      }
      const objectURL = 'data:image/jpeg;base64,' + caller.LogoBase64;
      this.logo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.callerReceivedSubcription = this.messageServerService.callerReceived
          .subscribe(( message ) => {
            this.zone.run(() => {

              this.loading = true;
              if (  !this.callers ) {
                this.callers = [];
              }
              const callerPatient = <CallerPatient>JSON.parse(message);
              this.setCallerPatient(callerPatient);
              this.loading = false;
            });

          });
    });
  }

  getheightVideo(): number { return  this.heightContent - this.heightLogo - 10; }

  get getCallers(): CallerPatient[] {
    return this.callers && this.callers.length > 0 ?
     this.callers.filter(c => c.Id !== this.getTopCaller.Id) : null;
  }

  get getTopCaller(): CallerPatient {
    return this.callers && this.callers.length > 0  ? this.callers[0] : null;
  }

  private setCallerPatient( callerPatient: CallerPatient ) {

    const index = this.callers.findIndex(c => c.Id === callerPatient.Id);

    if ( index > -1 ) {
      this.callers.splice(index, 1);
    }

    if ( !callerPatient.Deleted &&
          // this.isOrientation === callerPatient.IsOrientation &&
          this.sectorIds.findIndex(s => s === callerPatient.SectorId) > -1 ) {
      this.callers.unshift(callerPatient);

      if ( this.viewAmount && this.callers.length > this.viewAmount ) {
        this.callers.splice(this.callers.length  - 1, 1);
      }

      this.value = 'active';
      if ( this.soundName ) {
        this.playSound();
      }

      if ( this.showAlert ) {
        this.showCallerAlert(callerPatient);
      }
    }
  }

  private playSound() {
    if ( this.audio ) {
      this.audio.pause();
      this.audio.currentTime = 0;
    } else {
      this.audio = new Audio();
      this.audio.src = `../../../../Content/Sound/${this.soundName}`;
      this.audio.load();
    }
    this.audio.play();
  }

  private showCallerAlert( callerPatient: CallerPatient ) {
    const text =  `<h1 style="color: ${ this.callerTextColor } ;">${  this.viewPatient ? callerPatient.Patient : callerPatient.CallerText } </h1>`;
    Swal.fire({
      position: 'top-end',
      title: text,
      html: `<h1 style="color: ${ this.callerTextColor } ;">${ callerPatient.Location  }</h1>`,
      showConfirmButton: false,
      timer: 2000
    });
  }

  onResizedContent(event: ResizedEvent): void {
    this.heightContent = event.newHeight;
  }

  onResizedLogo(event: ResizedEvent): void {
    this.heightLogo = event.newHeight;
  }
}
